var _circle, _circle2, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalSteg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12003_113129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12003_113129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2354 54.1475C51.125 52.5683 52.6034 55.9954 52.7378 58.3138C52.5362 61.909 50.117 64.093 45.413 64.1602C40.7426 64.2274 33.7874 58.5154 33.9218 49.2755C34.0562 40.0355 40.2722 31.6355 47.261 25.7891C54.2498 19.9427 45.3458 28.9475 44.0018 30.7283C42.6578 32.5091 37.2482 38.4899 38.021 48.1667C38.5922 55.1218 44.573 57.1378 45.4466 57.1378C47.8994 57.1378 48.9746 56.4322 48.9746 55.5922C49.0418 54.7858 48.7058 54.7187 48.2354 54.1475Z",
    fill: "#1170B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.781 52.6346C46.0514 52.7354 45.7154 50.5514 45.8162 49.241C45.917 47.9306 48.1682 46.1162 48.3362 45.4106C48.5042 44.705 48.3026 43.9658 48.3026 43.9658C48.3026 43.9658 49.781 44.2346 50.3858 45.1418C50.9906 46.049 51.0914 47.393 50.3522 48.0986C49.5794 48.8042 48.773 49.2746 48.773 50.1818C48.773 51.089 49.1762 52.601 49.781 52.6346Z",
    fill: "#EB3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7057 44.201C45.1777 43.0586 45.5473 40.9082 46.0513 39.6986C46.5553 38.489 49.3105 37.5146 49.7137 36.9098C50.1169 36.305 50.1505 35.5322 50.1505 35.5322C50.1505 35.5322 51.4609 36.2714 51.7297 37.313C51.9985 38.3546 51.6625 39.6986 50.7217 40.1018C49.7809 40.505 48.8737 40.7066 48.5713 41.5802C48.2353 42.4538 48.1345 43.9658 48.7057 44.201Z",
    fill: "#EB3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5543 35.868C47.0263 34.7256 47.3959 32.5752 47.8999 31.3656C48.4039 30.156 51.1591 29.1816 51.5623 28.5768C51.9655 27.972 51.9991 27.1992 51.9991 27.1992C51.9991 27.1992 53.3095 27.9384 53.5783 28.98C53.8471 30.0216 53.5111 31.3656 52.5703 31.7688C51.6295 32.172 50.7223 32.3736 50.4199 33.2472C50.0839 34.0872 50.0167 35.6328 50.5543 35.868Z",
    fill: "#EB3124"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalSteg);
export default __webpack_public_path__ + "static/media/logoModalSteg.46fa176175d3c506572e24a2ce522f91.svg";
export { ForwardRef as ReactComponent };